import { IEntityTypePayload } from '../entity-data/entity-data.actions';
import { EntityTypesEnum } from '../../app.enum';

export interface IBillAppointmentPayload extends IEntityTypePayload {
  appointmentId: string;
  clientReferenceId: string;
}

// action enums
export enum ActionsEnum {
  BILL_APPOINTMENT = 'BILL_APPOINTMENT',
}

export interface BillAppointment {
  type: ActionsEnum.BILL_APPOINTMENT;
  payload: IBillAppointmentPayload;
}

export const billAppointment = (
  entityType: EntityTypesEnum,
  appointmentId: string,
  clientReferenceId: string
): BillAppointment => ({
  type: ActionsEnum.BILL_APPOINTMENT,
  payload: {
    entityType,
    appointmentId,
    clientReferenceId,
  },
});
